import { render, staticRenderFns } from "./ArchivedIcon.vue?vue&type=template&id=6d457229"
import script from "./ArchivedIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArchivedIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports